import classNames from 'classnames'
import React from 'react'
import { Link } from 'react-router'

import { type Breadcrumb } from '~/routes/utils'
import { exists } from '~/utils'

import { Icon } from '../Icon'

import styles from './Breadcrumbs.css'

export type BreadcrumbsProps = {
  'data-testid'?: string
  items: Breadcrumb[]
}

export const Breadcrumbs = ({
  'data-testid': dataTestId = 'components-elements-breadcrumbs',
  items,
}: BreadcrumbsProps) => (
  <nav className={styles.root} data-testid={dataTestId}>
    {items.map(({ disabled = false, label, to }, index) => (
      <React.Fragment key={`${label}-${to}-${index}`}>
        {index !== 0 && <Icon icon="arrow-chevron-right" size="1em" />}

        <span className={classNames({ [styles.normal]: !disabled })}>
          {exists(to) && index !== items.length - 1 ? (
            <Link to={to}>{label}</Link>
          ) : (
            label
          )}
        </span>
      </React.Fragment>
    ))}
  </nav>
)
